// extracted by mini-css-extract-plugin
export var base = "_4w-0";
export var updateBanner = "_4w-1";